import React, { useEffect, useState } from "react";
import "./demo.css";
import Verify from "../lottie/Animation - 1704887243322.json";
import Lottie from "react-lottie";

const DemoDonation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Verify,
  };
  const [data, setdata] = useState();
  useEffect(() => {
    // Get the URLSearchParams object from the current URL
    const urlSearchParams = new URLSearchParams(window.location.search);

    // Get the value of the 'data' parameter
    const dataValue = urlSearchParams.get("data");

    // Log or use the data value as needed
    console.log("Data Value:", dataValue);
    setdata(JSON.parse(dataValue));

    // You can set it to the state or perform any other actions with the data
  }, []);
  return (
    <div class="container">
      <Lottie options={defaultOptions} height={300} width={300} />
      <br />
      <div>
        {" "}
        <center>
          {" "}
          ಸ್ವಚ್ಚ, ಪ್ರಾದೇಶಿಕ, ಪ್ರಾಮಾಣಿಕ, ಜನಪರ ರಾಜಕಾರಣದ ಮೂಲಕ ಕರ್ನಾಟಕದ ಸಮಗ್ರ
          ಅಭಿವೃದ್ಧಿಗಾಗಿ ಶ್ರಮಿಸುತ್ತಿರುವ KRS ಪಕ್ಷವನ್ನು ಬೆಂಬಲಿಸಿದ್ದಕ್ಕಾಗಿ ತಮಗೆ
          ಹೃತ್ಪೂರ್ವಕ ಧನ್ಯವಾದಗಳು. ನಿಮ್ಮ ದೇಣಿಗೆ ನಮಗೆ ಅತ್ಯಮೂಲ್ಯ. ಅದನ್ನು ಜತನದಿಂದ
          ಬಳಸುತ್ತೇವೆ, ಪಾರದರ್ಶಕತೆ ಕಾಪಾಡುತ್ತೇವೆ. 
          <br/>
          Thank you for joining hands with
          KRS party in its goal of comprehensive development of Karnataka
          through Clean, Honest, Pro-people Politics. Your contribution is very
          Valuable. We will use it very Diligently and maintain Transparency.
          <br/>
          ವಾಟ್ಸಾಪ್ ಗ್ರೂಪ್ ಸೇರಲು ಕ್ಲಿಕ್ ಮಾಡಿ - ಸೇರಿ To Join Whatsapp
          Group please click <b> </b>
          <br />
          <br />
          <a class="button-4" href={"https://chat.whatsapp.com/IKuW0xOAkSOGU9ZChRjjMV"}>
            {" "}
            ಕೆಆರ್‌ಎಸ್ ಪಕ್ಷದ ವಾಟ್ಸಾಪ್ ಗ್ರೂಪ್‌ಗೆ ಸೇರಿಕೊಳ್ಳಿ ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ
          </a>
          <br />
          <br />
          <br />
          {/* <a
            class="button-4"
            href="https://wa.me/+91your-mobile-number?text=https://your-whatsapp-link"
          >
            ಸೇರ್ಪಡೆಗೊಂಡ ನೂತನ ಸದಸ್ಯರಿಗೆ WhatsApp ಗ್ರೂಪ್ ಲಿಂಕ್ ಕಳುಹಿಸಲು ಇಲ್ಲಿ
            ಕ್ಲಿಕ್ ಮಾಡಿ
          </a> */}
          <br />
          <br />
          <br />
        </center>
        <br />
      </div>
    </div>
  );
};

export default DemoDonation;
